import queryString from 'query-string'
import { genericFetchingActionCreator } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'

const fetchCondosOrBuilders = (name, formattedName, url) => {
  return (dispatch) => {
    dispatch(genericFetchingActionCreator(name, 'fetching'))
    fetch(url, {
      credentials: 'include',
      method: 'GET'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, formattedName)
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        // TODO: even if somehow a validation exception got past the frontend check this isn't handled in the component, get rid of or handle?
        dispatch(genericFetchingActionCreator(name, 'error', responseJson.errors[0].message))
        throw new Error(responseJson.errors[0].message)
      } else { //success
        dispatch(genericFetchingActionCreator(name, 'fetched', { list: responseJson }))
      }
    }).catch((error) => {
      console.error(`${formattedName} fetching error: `, error)
    })
  }
}

export const newSearchHomeBuilder = () => dispatch => dispatch({ type: 'NEW_SEARCH_HOMEBUILDER' })
export const fetchHomeBuilders = ({ name, id, station, city, stateCode, firstName, lastName, searchType }) => {
  let query = encodeURIComponent(`builderId=${id}&builderName=${name}&builderCity=${city}&builderRegion=${station}&builderState=${stateCode}&principalFirstName=${firstName}&principalLastName=${lastName}&builderNameSearchType=${searchType}`)
  return fetchCondosOrBuilders('HOMEBUILDER', 'Builder Report', `api/builders/search?${query}`)
}

export const newSearchCondoReport = () => dispatch => dispatch({ type: 'NEW_SEARCH_CONDOREPORT' })
export const fetchCondoReport = ({ name, id, station, city, stateCode, county, approved }) => {
  let query = queryString.stringify({ condoName: name, condoId: id, station, city, stateCode, county, approved })
  return fetchCondosOrBuilders('CONDOREPORT', 'Condo Report', `api/condos/search?${query}`)
}
